function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCart = function SvgCart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 61 61",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-138,-67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cart",
    transform: "matrix(1.61997,0,0,1.61997,23.7302,52.6294)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.994,
    y: 9.469,
    width: 37.038,
    height: 37.038,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.15743,0,0,1.15743,70.7553,8.96341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.719,20.296L31.326,9.578C31.507,9.059 31.37,8.786 31.223,8.58C30.849,8.053 30.081,8.068 29.931,8.068L9.546,8.074L9.002,5.341C8.855,4.732 8.421,4 7.546,4L1.817,4C1.224,4 1,4.59 1,5.146L1,6.636C1,7.172 1.222,7 1.838,7L6.675,7L10.377,22.873C9.789,23.496 9.469,24.482 9.469,25.33C9.469,27.194 10.953,28.795 12.848,28.795C14.639,28.795 15.98,27 16.198,26L23.408,26C23.626,27 24.713,28.873 26.757,28.873C28.619,28.873 30.135,27.338 30.135,25.477C30.135,23.625 29.01,21.868 26.776,21.868C25.848,21.868 24.745,22.001 24.233,23.001L15.374,23.001C14.731,22.001 13.853,21.69 12.965,21.656L12.843,21L26.322,21C27.338,21 27.538,20.786 27.719,20.296ZM11.537,25.514C11.537,24.805 12.114,24.228 12.823,24.228C13.53,24.228 14.106,24.805 14.106,25.514C14.106,26.223 13.53,26.799 12.823,26.799C12.113,26.799 11.537,26.223 11.537,25.514ZM26.783,26.783C26.083,26.783 25.513,26.213 25.513,25.513C25.513,24.813 26.082,24.243 26.783,24.243C27.484,24.243 28.053,24.812 28.053,25.513C28.053,26.213 27.484,26.783 26.783,26.783Z",
    style: {
      fillRule: "nonzero"
    }
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cart.5bf058e2.svg";
export { ForwardRef as ReactComponent };